// Styles
import './style.css';

//assets
import { ReactComponent as IconoError } from '../../../assets/icons/Loader/Cotizar.svg';
import { cn } from '../../../lib';

const LoaderCotizar = ({ type = 'screen', variant = 'default', className = '', tituloLoader = '', subtituloLoader = '', estiloTitulo = '', estiloSubtitulo = '' }) => {
  const renderTexto = (texto, estilo) => {
    if (texto.trim().endsWith("...")) {
      const base = texto.replace(/\.\.\.$/, "");
      return (
        <div className={cn(estilo)}>
          {base}
          <span className="loader-dots">
            <span className="loader-dot">.</span>
            <span className="loader-dot">.</span>
            <span className="loader-dot">.</span>
          </span>
        </div>
      );
    } else {
      return (
        <div className={cn(estilo)}>
          {texto}
        </div>
      );
    }
  };

  // Variante específica para cards
  if (variant === 'card') {
    return (
      <div className={`absolute top-0 left-0 right-0 bottom-0 bg-white/90 z-50 rounded-md sticky ${className}`}>
        <div className="flex flex-col items-center justify-start pt-16">
          <IconoError />
          <div className='mt-4 flex flex-col items-center justify-center'>
            {tituloLoader && renderTexto(tituloLoader, estiloTitulo)}
            {subtituloLoader && renderTexto(subtituloLoader, estiloSubtitulo)}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      className={`${type === 'screen' ? 'h-screen loading w-screen' : 'h-full'
        } `}
    >
      <div
        id="contenedor"
        className={`flex flex-col items-center justify-center ${type === 'screen' && 'h-screen contenedor-loader'}`}
      >
        <IconoError />
        <div className='mt-4 flex flex-col items-center justify-center'>
          {tituloLoader && renderTexto(tituloLoader, estiloTitulo)}
          {subtituloLoader && renderTexto(subtituloLoader, estiloSubtitulo)}
        </div>
      </div>
    </div>
  );
};

export default LoaderCotizar;
